export const I18N_CACHE_PREFIX = 'i18next-res-';

export const getI18nCacheKey = (language: string, namespace: string) => `${I18N_CACHE_PREFIX}${language}-${namespace}`;

export const getI18nLastModifiedCacheKey = (language: string, namespace: string) =>
  `${getI18nCacheKey(language, namespace)}-lastmodified`;
